import {Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {addDriversApi, assignBusToDriver, getDriverApi, getDriversApi, removeDriverApi} from '../api/drivers';
import {
  addBusApi,
  assignDriverToBus,
  editBusApi,
  getBusApi,
  getBusesApi,
  getBusServicesApi,
  removeBusApi,
  unAssignDriverApi
} from '../api/bus';
import swal from "sweetalert2";
import * as _ from "lodash"
@Component({
  selector: 'app-bus',
  templateUrl: './bus.component.html',
  styleUrls: ['./bus.component.css']
})
export class BusComponent implements OnInit {

  constructor(private _fb: FormBuilder) { }

  data: FormGroup;
  rowSelected={}
  driverRow={}
  buses=[]
  drivers=[]
  editMode=false
  p: number = 1;

  loader=true
  ngOnInit() {

    this.data = this._fb.group({
      name:[''],
      bus_identity: ['', Validators.required],
      drivers: [],
      university: null,
      type: ['', Validators.required],
      plate: ['', Validators.required],
      capacity: ['', Validators.required],
      notes: [''],
      motor: [''],

    });
    this.getBuses()
    this.getDrivers()
  }

  async getDrivers(){
    let result=await getDriversApi()
    if(result){
      this.drivers=[]
      this.drivers=result.data.data
    }
  }
  selectedDrivers=[]

  assignToBus(driver,checked){

    if (this.selectedDrivers.includes(driver)) {
      this.selectedDrivers=[]
      // this.unSelectedBus.push(bus)
    } else {
      this.selectedDrivers=[]
      this.selectedDrivers.push(driver)

    }

    // if(this.selectedDrivers.includes(driver)||checked){
    //   this.selectedDrivers = this.selectedDrivers.filter(function(value, index, arr){
    //
    //     return value != driver;
    //
    //   });
    // }else {
    //   this.selectedDrivers.push(driver)
    // }

    console.log(this.selectedDrivers)
  }


  async getBuses(){
    let result=await getBusesApi()
    this.loader=true

  this.editMode=false
    this.data = this._fb.group({
      name: [''],
      bus_identity: ['', Validators.required],
      drivers: [],
      university: null,
      type: ['', Validators.required],
      plate: ['', Validators.required],
      capacity: ['', Validators.required],
      notes: [''],
      motor: [''],

    });
    this.rowSelected={}
    if(result){
      this.buses=[]
      this.buses=result.data.data
      this.loader=false


    }

  }

  busServices=[]
  oilBusServices=[]

 async getBusServices(busID){
    const data=await getBusServicesApi(busID)

   if(data){

     this.oilBusServices=data.data.data.filter(row=>row.type=='oil')
     this.busServices=data.data.data.filter(row=>row.type=='petrol')
     console.log(this.busServices)
   }

  }
  checkBusNumber(){

    let bus=_.keyBy(this.buses,'bus_identity')

    if(!this.editMode){
      return bus[this.data.get('bus_identity').value]?true:false

    }
    return false

  }

  async unAssignDriver(busID,driverID){
    let result=await unAssignDriverApi(busID,driverID)

    if(result){
      this.getBuses()
      this.getDrivers()

    }

  }

  async getBus(id){
    let result=await getBusApi(id)
    this.editMode=true
console.log(this.editMode)
    if(result){

      let bus=result.data.data
      this.rowSelected=bus

      this.data = this._fb.group({
        name: [bus.name],
        bus_identity: [bus.bus_identity, Validators.required],
        drivers: [bus.drivers],
        university: bus.university,
        type: [bus.type, Validators.required],
        plate: [bus.plate, Validators.required],
        capacity: [bus.capacity, Validators.required],
        notes: [bus.notes],
        motor: [bus.motor],

      });

    }

  }

  selectedRow(row){
    this.rowSelected={}
    this.rowSelected=row
    this.selectedDrivers=row.drivers_id
  }

  selectedDriverRow(row,driver){
    this.driverRow={}
    this.driverRow=driver
    this.rowSelected=row
  }

  changeEditMode(){
    this.editMode=false
    this.data = this._fb.group({
      name: [''],
      bus_identity: ['', Validators.required],
      drivers: [],
      university: null,
      type: ['', Validators.required],
      plate: ['', Validators.required],
      capacity: ['', Validators.required],
      notes: [''],
      motor: [''],

    });
  }

  async removeBus(id){
    let result=await removeBusApi(id)

    if(result){

      let driver=result.data.data
      swal(
        'تم انتهاء  العملية بنجاح',
        '',

        'success'
      )
this.getBuses()

    }else {
      swal(
        'حصل خطأ، يرجى المحاولة مرة أخرى',
        '',

        'error'
      )
    }

  }
  async edit() {
    let data=this.data.value


    let result=await editBusApi(data,this.rowSelected['_id'])

    if(result){
      swal(
        'تم انتهاء  العملية بنجاح',
        '',

        'success'
      )
      this.getBuses()
    }else {
      swal(
        'حصل خطأ، يرجى المحاولة مرة أخرى',
        '',

        'error'
      )
    }


    console.log(this.data.value)
  }

  async add() {
    let data=this.data.value


    let result=await addBusApi(data)

    if(result){
      swal(
        'تم انتهاء  العملية بنجاح',
        '',

        'success'
      )
      this.getBuses()
    }else {
      swal(
        'حصل خطأ، يرجى المحاولة مرة أخرى',
        '',

        'error'
      )
    }

    console.log(this.data.value)
  }
  @ViewChild("search")
  public searchElementRef: ElementRef;
  @ViewChild("search2")
  public searchElementRef2: ElementRef;
  removeSearch() {
    this.searchElementRef.nativeElement.value=""
    this.searchElementRef2.nativeElement.value=""
  }

  async saveAssignBus() {
    let data=this.selectedDrivers
    let result=await assignDriverToBus(data,this.rowSelected['_id'])

    if(result){
      this.getDrivers()
      this.getBuses()
      this.selectedDrivers=[]
      swal(
        'تم انتهاء  العملية بنجاح',
        '',

        'success'
      )
    }else {
      swal(
        'حصل خطأ، يرجى المحاولة مرة أخرى',
        '',

        'error'
      )
    }


  }
}
